import React from 'react';
import { UCAModule, CommonModule, isFeatureFlagEnabled } from "uca-react-containers-library";
import Loader from './loader';

const AccountDashboardComponent = () => {
    const {isLoading } = CommonModule.useAuth();
    const { saveRouteData } = CommonModule.useRoute();
    const isMEAccountDashboardEnabled = isFeatureFlagEnabled('enableMEAccountDashboard');

    React.useEffect(() => {
        saveRouteData({ 'currentPage': 'My Account' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderAccountDashboard = () => {
        if (isMEAccountDashboardEnabled) {
            return <UCAModule.AccountDashboardV3 />;
        } else {
            return <UCAModule.AccountDashboardV2 />;
        }
    };

    if (isLoading) return <Loader></Loader>;

    return (
        <CommonModule.ViewportProvider>
            <h1 className="sr-only">Account Dashboard</h1>
            <div class="col-lg-3 col-xl-3">
                <UCAModule.LeftNavigation></UCAModule.LeftNavigation>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
               {renderAccountDashboard()}
            </div>
        </CommonModule.ViewportProvider>
    );
};

export default AccountDashboardComponent;
